import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';

import { Observable, Subject, ReplaySubject } from 'rxjs';


import { UserInfoService, LoginInfoInStorage } from './user-info.service';
import { ApiRequestService } from './api-request.service';



@Injectable()
export class GroupPolicyService {
    constructor(
        private http: Http,
        private apiRequest: ApiRequestService
    ) { }



    submitGroupPolicy(grpPolicyIO,formData){
        let me = this;
        
        let occupationDataSubject = new Subject<any>(); // Will use this subject to emit data that we want
        this.apiRequest.postForMultipart('groupPolicy/submitGroupPolicy',formData)
            .subscribe(jsonResp => {
            
              let returnObj = jsonResp;
                console.log(returnObj);
                occupationDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return occupationDataSubject;

    }


    saveGroupPolicy(grpPolicyIO,formData){
        let me = this;
        let occupationDataSubject = new Subject<any>(); // Will use this subject to emit data that we want
     this.apiRequest.post('groupPolicy/saveGroupPolicy',grpPolicyIO)
            .subscribe(jsonResp => {
            
              let returnObj = jsonResp;
                console.log(returnObj);
                occupationDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return occupationDataSubject;

    }



    submitRetailPolicy(bulkProcessLog,formData)
    {

        let me = this;
        let occupationDataSubject = new Subject<any>(); 
     this.apiRequest.postForMultipart('retailPolicy/submitPolicies',formData)
            .subscribe(jsonResp => {
            
              let returnObj = jsonResp;
                console.log(returnObj);
                occupationDataSubject.next(returnObj); 
            });

        return occupationDataSubject;

    }

    
    searchGenericBatchLog(searchRequestDO,pageNum, pageSize): Observable<any> {
        let self = this;
        let quotationDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);// Will use this subject to emit data that we want after ajax save quote attempt
        this.apiRequest.post('retailPolicy/searchBulkLogForAgent'+'?page=' + pageNum + '&size=' + pageSize , searchRequestDO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Search successful")
                    console.log(JSON.stringify(jsonResp))
                } else {
                    console.log("Search failed")
                    console.log(jsonResp)
                }
                quotationDataSubject.next(jsonResp);

            }, errResp => {
                quotationDataSubject.next(errResp);
            })
        return quotationDataSubject;
    }



    searchGenericGroupPolicyLog(searchRequestDO,pageNum, pageSize): Observable<any> {
        let self = this;
        let quotationDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);// Will use this subject to emit data that we want after ajax save quote attempt
        this.apiRequest.post('groupPolicy/searchGroupPolicyLog'+'?page=' + pageNum + '&size=' + pageSize ,searchRequestDO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Search successful")
                    console.log(JSON.stringify(jsonResp))
                } else {
                    console.log("Search failed")
                    console.log(jsonResp)
                }
                quotationDataSubject.next(jsonResp);

            }, errResp => {
                quotationDataSubject.next(errResp);
            })
        return quotationDataSubject;
    }





    fetchBulkPolicyById(id): Observable<any> {
        let self = this;
        let quotationDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);// Will use this subject to emit data that we want after ajax save quote attempt
        this.apiRequest.get('retailPolicy/fetchById/'+id)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Search successful")
                    console.log(JSON.stringify(jsonResp))
                } else {
                    console.log("Search failed")
                    console.log(jsonResp)
                }
                quotationDataSubject.next(jsonResp);

            }, errResp => {
                quotationDataSubject.next(errResp);
            })
        return quotationDataSubject;

 }


 fetchFleetPolicyByGroupId(id): Observable<any> {
    let self = this;
    let quotationDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);// Will use this subject to emit data that we want after ajax save quote attempt
    this.apiRequest.get('groupPolicy/fetchById/'+id)
        .subscribe(jsonResp => {
            if (jsonResp !== undefined) {
                    console.log(JSON.stringify(jsonResp))
            } else {
                console.log("Search failed")
                console.log(jsonResp)
            }
            quotationDataSubject.next(jsonResp);

        }, errResp => {
            quotationDataSubject.next(errResp);
        })
    return quotationDataSubject;

}


getGroupPolicyByGuid(guid: String): Observable<any> {
    
    let self = this;
    let groupPolicyDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);// Will use this subject to emit data that we want after ajax save quote attempt
    this.apiRequest.get('groupPolicy/fetchByGuid/' + guid)
        .subscribe(jsonResp => {
            if (jsonResp !== undefined) {
                   // console.log(JSON.stringify(jsonResp))
            } else {
                
                console.log(jsonResp)
            }
            groupPolicyDataSubject.next(jsonResp);

        }, errResp => {
            groupPolicyDataSubject.next(errResp);
        })
    return groupPolicyDataSubject;
}



}
